module.exports = __webpack_public_path__ + "img/landing_box21.cf4dd2cb.jpg";